import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { capitalizeFirstLetter, formateDate } from "../../../../utils/commonfunction";
import * as businessServices from "../../services/business.services";
import { useTranslation } from "react-i18next";

const BusinessView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const [hoveredImage, setHoveredImage] = useState(null);

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    { title: "Business", url: "/admin/business/list/1" },
    { title: t("btn_view"), url: "" },
  ];

  useEffect(() => {
    businessServices
      .Details(params.id)
      .then((response) => {
        setShowDefault(response && response.data ? response.data : {});
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  const renderBusinessHours = (businessHours) => {
    if (!Array.isArray(businessHours) || businessHours.length === 0) {
      return "N/A";
    }

    return (
      <div>
        {businessHours.map((hour, idx) => (
          <div key={idx} className="mb-2">
            <strong>{hour.day}:</strong>{" "}
            {hour.is_open ? (
              <span className="text-success">
                Open ({hour.open_time} - {hour.close_time})
              </span>
            ) : (
              <span className="text-danger">Closed</span>
            )}
          </div>
        ))}
      </div>
    );
  };

  const renderImage = (imagePath, altText, imageKey, height = "100px") => {
    const scaleStyle = {
      transform: hoveredImage === imageKey ? "scale(5)" : "scale(1)",
      transition: "transform 0.3s ease",
      display: "inline-block",
      zIndex: hoveredImage === imageKey ? 1000 : "auto",
      position: "relative",
      cursor: "pointer",
    };

    if (!imagePath) return "N/A";
    return <img onMouseEnter={() => setHoveredImage(imageKey)} onMouseLeave={() => setHoveredImage(null)} src={imagePath} alt={altText || "Business Image"} style={{ height, maxWidth: "200px", objectFit: "cover", ...scaleStyle }} className="img-thumbnail hover:scale-200" />;
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">View Business</h6>
              </div>

              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table id="simple-table" className="table table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th>Business Name</th>
                          <td className="text-capitalize">{capitalizeFirstLetter(showdefault.business_name) || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("Email")}</th>
                          <td>{showdefault.email || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("label_phone_number")}</th>
                          <td>{showdefault.phone_number.fullNumber || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Category Name</th>
                          <td className="text-capitalize">{capitalizeFirstLetter(showdefault.category_id?.title) || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Subcategory Name</th>
                          <td className="text-capitalize">{capitalizeFirstLetter(showdefault.subcategory_id?.title) || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>VAT Number</th>
                          <td>{showdefault.vat_number || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Bank Details</th>
                          <td style={{ whiteSpace: "pre-wrap" }}>{showdefault.bank_details || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Offer Percentage</th>
                          <td>{showdefault.offer_percentage ? `${showdefault.offer_percentage}%` : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("label_address")}</th>
                          <td>{capitalizeFirstLetter(showdefault.address) || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Country</th>
                          <td className="text-capitalize">{showdefault.country || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>State</th>
                          <td className="text-capitalize">{showdefault.state || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>City</th>
                          <td className="text-capitalize">{showdefault.city || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Post Code</th>
                          <td>{showdefault.zip_code || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Latitude/Longitude</th>
                          <td>{showdefault.latitude && showdefault.longitude ? `${showdefault.latitude}, ${showdefault.longitude}` : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Role</th>
                          <td className="text-capitalize">{showdefault.role || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Status</th>
                          <td>{showdefault.status !== undefined ? <span className={`badge ${showdefault.status === 1 ? "bg-success" : "bg-danger"}`}>{showdefault.status === 1 ? "Active" : "Inactive"}</span> : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Account Provider</th>
                          <td className="text-capitalize">{showdefault.accountProvider || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Email Verified</th>
                          <td>
                            <span className={`badge ${showdefault.isEmailVerified !== false ? "bg-success" : "bg-warning"}`}>{showdefault.isEmailVerified !== false ? "Verified" : "Not Verified"}</span>
                          </td>
                        </tr>
                        <tr>
                          <th>Admin Approved</th>
                          <td>
                            <span className={`badge ${showdefault.isVerified ? "bg-success" : "bg-warning"}`}>{showdefault.isVerified ? "Approved" : "Not Approved"}</span>
                          </td>
                        </tr>
                        <tr>
                          <th>Profile Complete</th>
                          <td>
                            <span className={`badge ${showdefault.isCompleteProfile ? "bg-success" : "bg-warning"}`}>{showdefault.isCompleteProfile ? "Complete" : "Incomplete"}</span>
                          </td>
                        </tr>
                        <tr>
                          <th>Terms & Conditions</th>
                          <td>
                            <span className={`badge ${showdefault.isTermsConditionAccept ? "bg-success" : "bg-danger"}`}>{showdefault.isTermsConditionAccept ? "Accepted" : "Not Accepted"}</span>
                          </td>
                        </tr>
                        <tr>
                          <th>Profile Image</th>
                          <td>{renderImage(showdefault.profile_image, "Profile Image", "profile")}</td>
                        </tr>
                        <tr>
                          <th>Brochure</th>
                          <td>{renderImage(showdefault.brochure, "Business Brochure", "brochure")}</td>
                        </tr>
                        <tr>
                          <th>Business Hours</th>
                          <td>{renderBusinessHours(showdefault.business_hours)}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>{showdefault.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                        </tr>
                        {showdefault.description && (
                          <tr>
                            <td colSpan={2}>
                              <h6 className="main-content-label mb-3">{t("label_description")}:</h6>
                              <div
                                className="text-capitalize"
                                dangerouslySetInnerHTML={{
                                  __html: showdefault.description,
                                }}
                              />
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    <div className="mt-5">
                      <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        back
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BusinessView;
